import { LoadingOverlayComponent } from '../shared/components/loading-overlay/loading-overlay.component';
import { WordpressTeaserComponent } from '../shared/wordpress/wordpress-teaser.component';
import { DashboardAmpelComponent } from './ampel/dashboard-ampel.component';
import { DashboardEgpComponent } from './egp/dashboard-egp.component';
import { DashboardEppComponent } from './epp/dashboard-epp.component';
import { DashboardGmaAlarmComponent } from './gma-alarm/dashboard-gma-alarm.component';
import { DashboardInfoComponent } from './info/dashboard-info.component';
import { DashboardRadarComponent } from './radar/dashboard-radar.component';
import { DashboardSmwComponent } from './smw/dashboard-smw.component';
import { DashboardWarningComponent } from './warning/dashboard-warning.component';
import { DashboardWarnmapComponent } from './warnmap/dashboard-warnmap.component';

import { AuthService } from '../auth/auth.service';
import { ImageService } from '../cache/image.service';
import { EgpSeason, EgpService } from '../egp/egp.service';
import { RadarService } from '../radar/radar.service';
import { WarningService } from '../warning/warning.service';
import { DashboardInfoService } from './info/dashboard-info.service';

import { MomentPipe } from '../pipes/moment.pipe';
import { DatexPipe } from '../shared/datex.pipe';
import { KeyPipe } from '../shared/key.pipe';

import {
  CdkDrag,
  CdkDragDrop,
  CdkDragHandle,
  CdkDropList,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Platform } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  inject,
  OnDestroy,
  OnInit,
  signal,
  viewChild,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbar } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { isNil } from '../../utils/utils';
import { TippyDirective } from '@ngneat/helipopper';
import moment from 'moment';
import rg4js from 'raygun4js';
import { map, Subscription, timer } from 'rxjs';

export const MODULES = [
  CommonModule,
  MatSidenavModule,
  MatIconModule,
  MatButtonModule,
  RouterModule,
  MatCardModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatSelectModule,
  MatMenuModule,
  ReactiveFormsModule,
  MatTooltipModule,
  MatListModule,
  FormsModule,
  TranslateModule,
];
export const COMPONENTS = [
  FaIconComponent,
  WordpressTeaserComponent,
  DashboardInfoComponent,
  DashboardAmpelComponent,
  DashboardWarningComponent,
  DashboardGmaAlarmComponent,
  DashboardRadarComponent,
  DashboardEgpComponent,
  DashboardEppComponent,
  DashboardSmwComponent,
  DashboardWarnmapComponent,
  LoadingOverlayComponent,
  MatToolbar,
];
export const PIPES = [KeyPipe, MomentPipe];
export const DIRECTIVES = [
  TippyDirective,
  CdkDropList,
  CdkDrag,
  CdkDragHandle,
];

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [ImageService],
  imports: [...MODULES, ...COMPONENTS, ...PIPES, ...DIRECTIVES, DatexPipe],
})
export class DashboardComponent implements OnInit, OnDestroy {
  private platform = inject(Platform);
  private breakpointObserver = inject(BreakpointObserver);
  public translate = inject(TranslateService);
  private auth = inject(AuthService);
  private radarService = inject(RadarService);
  private egpService = inject(EgpService);
  private router = inject(Router);
  public warningService = inject(WarningService);
  private sanitizer = inject(DomSanitizer);
  private dashboardInfoService = inject(DashboardInfoService);

  accordionAdd = viewChild<MatAccordion>('accordionAdd');
  accordionEdit = viewChild<MatAccordion>('accordionEdit');
  drawer = viewChild<MatDrawer>('drawer');

  isLoading = signal(true);

  cardConfig = {
    radar: {
      width: 340,
      icon: 'umbrella',
    },
    egp: {
      width: 340,
      icon: 'border-all',
    },
    egw: {
      width: 340,
      icon: 'exclamation-triangle',
    },
    epp: {
      width: 694,
      icon: 'clouds-sun',
    },
    smw: {
      width: 340,
      icon: 'thermometer-half',
    },
    ampel: {
      width: 694,
      icon: 'traffic-light',
    },
    dwd: {
      width: 340,
      icon: 'thunderstorm',
    },
    warnmap: {
      width: 340,
      icon: 'thunderstorm',
    },
  };

  cards = signal([]);
  typeOfCard = signal({});
  routeOfCard = signal({});
  topCards = signal([]);
  useStoredDashboard = false;
  isSomethingOrdered = signal(false);

  radar = signal<any>(undefined);
  egp = signal<any>(undefined);
  epp = signal<any>(undefined);
  smw = signal<any>(undefined);
  egw = signal<any>(undefined);
  warnmap = signal<any>(undefined);
  nakedDashboard = signal<boolean>(false);

  allEgpRegions = {
    summer: [],
    winter: [],
  };

  showSettings = signal(false);

  availableProducts = signal({
    ampel: [],
    radar: {},
    egp: [],
    epp: [],
    smw: [],
    egw: [],
    dwd: [],
    warnmap: {},
  });

  radarRegionSelectControl = signal({});
  radarZoomSelectControl = signal({});
  egpRegionSelectControls = signal({});
  egpViewSelectControls = signal({});
  smwRegionSelectControls = signal({});
  eppStationSelectControls = signal({});
  eppParametersetSelectControls = signal({});
  eppResolutionSelectControls = signal({});
  eppViewSelectControls = signal({});
  egwRegionSelectControls = signal({});
  warnmapSourceSelectControls = signal({});
  warnmapParameterSelectControls = signal({});

  positionSelectControls = {
    radar: new UntypedFormControl(0),
    egp: new UntypedFormControl(0),
    epp: new UntypedFormControl(0),
    smw: new UntypedFormControl(0),
    ampel: new UntypedFormControl(0),
    egw: new UntypedFormControl(0),
    dwd: new UntypedFormControl(0),
    warnmap: new UntypedFormControl(0),
  };
  eppViewIcons = { table: 'th', meteogram: 'analytics' };
  egpViewIcons = { riskbox: 'border-all', text: 'align-left' };

  radarDtg = signal({
    de: null,
    eu: null,
    es: null,
    benelux: null,
    fr: null,
  });
  radarRegions = [];

  ampelDtg = signal<string>(undefined);
  eppLastIssueTimes = signal<Record<string, string>>({});
  selectedDashboardCard = signal<string | null>(null);
  contextMenuCard = signal<string | null>(null);
  contextMenuPosition = { x: 0, y: 0 };
  urlDwdMap =
    'https://maps.dwd.de/geoserver/dwd/ows?service=WMS&version=1.3&request=GetMap&layers=dwd:bluemarble,dwd:Warngebiete_Kreise,dwd:Warnungen_Gemeinden_vereinigt&styles=&bbox=5.0,47.2,16,55.1&width=320&height=330&srs=EPSG:4326&format=image%2Fpng';
  safeUrlDwdMap = signal<SafeResourceUrl>(undefined);

  // Auto-Refresh
  dashboardSub: Subscription;
  refreshCounter = 0;
  refresh = signal({
    radar: { counter: 0, interval: 2 },
    smw: { counter: 0, interval: 2 },
    epp: { counter: 0, interval: 5 },
    dwd: { counter: 0, interval: 5 },
    warnmap: { counter: 0, interval: 5 },
    egp: { counter: 0, interval: 5 },
    warn: { counter: 0, interval: 3 },
    info: { counter: 0, interval: 5 },
    ampel: { counter: 0, interval: 2 },
    customerDocument: { counter: 0, interval: 480 },
  });

  get getLanguage() {
    return this.auth.getLanguage();
  }

  private handset = toSignal(
    this.breakpointObserver
      .observe(['(max-width: 900px)'])
      .pipe(map(r => r.matches)),
    {
      initialValue: this.breakpointObserver.isMatched(['(max-width: 950px)']),
    }
  );

  readonly isMobilePlatform = computed(
    () => this.handset() || this.platform.ANDROID || this.platform.IOS
  );

  constructor() {
    this.safeUrlDwdMap.set(
      this.sanitizer.bypassSecurityTrustResourceUrl(
        this.urlDwdMap + '&refresh' + this.refresh().dwd
      )
    );
  }

  ngOnInit() {
    this.isLoading.set(true);
    this.initComponent();
  }

  async initComponent() {
    this.nakedDashboard.set(this.auth.isBambergDisplayUser());
    await this.checkLoadingEgpRegions();
    await this.readDashboardSettings();
    this.isLoading.set(false);

    this.dashboardSub = timer(0, 60000).subscribe(t => {
      this.updateRefreshTimer();
    });
  }

  ngOnDestroy(): void {
    if (this.dashboardSub) {
      this.dashboardSub.unsubscribe();
    }
  }

  private parseEgpCardName(cardName: string): {
    view: 'riskbox' | 'text';
    season: EgpSeason;
    region: string;
  } {
    const parts = cardName.split('_');

    if (parts.length >= 4 && ['riskbox', 'text'].includes(parts[1])) {
      return {
        view: parts[1] as 'riskbox' | 'text',
        season: parts[2] as EgpSeason,
        region: parts.slice(3).join('_'),
      };
    }

    return {
      view: 'riskbox',
      season: parts[1] as EgpSeason,
      region: parts.slice(2).join('_'),
    };
  }

  private buildEgpCardName(
    view: 'riskbox' | 'text',
    season: EgpSeason | string,
    region: string
  ): string {
    return view === 'riskbox'
      ? `egp_${season}_${region}`
      : `egp_${view}_${season}_${region}`;
  }

  openCardContextMenu(
    event: MouseEvent,
    card: string,
    trigger: MatMenuTrigger
  ): void {
    event.preventDefault();
    event.stopPropagation();

    this.contextMenuCard.set(card);
    this.contextMenuPosition = {
      x: event.clientX,
      y: event.clientY,
    };

    trigger.openMenu();
  }

  openCardSettings(drawer: { open: () => void }, card: string): void {
    this.selectedDashboardCard.set(card);
    this.showSettings.set(true);
    drawer.open();
  }

  openAddCardSettings(drawer: { open: () => void }): void {
    this.selectedDashboardCard.set(null);
    this.showSettings.set(false);
    drawer.open();
  }

  closeCardSettings(): void {
    this.selectedDashboardCard.set(null);
    this.showSettings.set(false);
  }

  async updateRefreshTimer(): Promise<void> {
    this.refreshCounter++;
    for (const product of Object.keys(this.refresh())) {
      if (this.refreshCounter % this.refresh()[product].interval === 0) {
        this.refresh.update(refresh => {
          refresh[product].counter++;
          return { ...refresh };
        });
        if (product === 'dwd') {
          this.updateDwdMap();
        } else if (product === 'radar') {
          this.updateRadar();
        } else if (product === 'customerDocument') {
          this.auth.refreshCustomerDocument();
        }
      }
    }
  }

  async checkLoadingEgpRegions(): Promise<void> {
    if (this.auth.isPigeonCustomer()) {
      return;
    }
    // winter
    if (
      this.auth.isProductActive('egpProducts') ||
      this.auth.isProductActive('egwProducts')
    ) {
      this.allEgpRegions.winter = await this.egpService.getAllEgpAreas(
        EgpSeason.WINTER
      );
    }
    if (this.auth.isProductActive('egpSummerProducts')) {
      this.allEgpRegions.summer = await this.egpService.getAllEgpAreas(
        EgpSeason.SUMMER
      );
    }
  }

  async readDashboardSettings(): Promise<void> {
    this.cards.set([]);
    if (!this.auth.getCustomerAlias()) {
      const settings = localStorage.getItem('dashboard');
      if (settings) {
        this.cards.set([...JSON.parse(settings)]);
        this.useStoredDashboard = true;
      } else {
        const userProfile = this.auth.getUserProfile();
        if (
          userProfile &&
          userProfile['metadata'] &&
          userProfile['metadata'].hasOwnProperty('global')
        ) {
          const global = userProfile['metadata']['global'];
          if (global && global.hasOwnProperty('dashboard')) {
            this.cards.set([...global['dashboard']]);
            this.useStoredDashboard = true;
          }
        }
      }
    }
    await this.initDashboard();
  }

  async initDashboard(): Promise<void> {
    this.initAmpel();
    this.initWarnings();
    this.initGmaAlarm();
    this.initRadar();
    if (this.showRiskbox()) this.initEgp();
    this.initSmw();
    this.initEpp();
    await this.initWarnmap();
    await this.initDwdWarnmap();
    this.cleanupInvalidCards();
  }

  showRiskbox(): boolean {
    if (this.auth.isPigeonCustomer()) {
      return false;
    }
    if (
      this.getLanguage === 'es' ||
      this.getLanguage === 'nl' ||
      this.getLanguage === 'fr'
    ) {
      return false;
    }
    return true;
  }

  cleanupInvalidCards(): void {
    for (const card of this.cards()) {
      if (!this.typeOfCard().hasOwnProperty(card)) {
        this.onRemoveCard(card);
      }
    }
  }

  egpRegionName(id, season): string {
    return this.allEgpRegions[season].filter(a => a.id == id)[0]?.name;
  }

  async initWarnings(): Promise<void> {
    if (
      this.auth.isProductActive('egwProducts') ||
      this.auth.isProductActive('egwSummerProducts')
    ) {
      this.isSomethingOrdered.set(true);
      this.topCards.update(topCards => {
        return [...topCards, 'egw'];
      });
      this.egw.set({});
      const customerDocument = this.auth.getCustomerDocument();
      const egwProducts = customerDocument['egwProducts'].concat(
        customerDocument['egwSummerProducts']
      );
      for (const egwProduct of egwProducts) {
        if (
          this.auth.isProductActive('egwProducts', egwProduct.id) ||
          this.auth.isProductActive('egwSummerProducts', egwProduct.id)
        ) {
          const egwSeason =
            egwProduct.classType === 'EGWProduct' ? 'winter' : 'summer';
          const egwRegion =
            egwSeason === 'winter' ? egwProduct.areaId : egwProduct.id;
          const regionName =
            egwSeason === 'winter'
              ? this.egpRegionName(egwRegion, 'winter')
              : egwProduct.points[0].searchName;
          const cardName = 'egw_' + egwSeason + '_' + egwRegion;
          this.egw.update(egw => {
            return {
              ...egw,
              [cardName]: {
                season: egwSeason,
                region: egwRegion,
                name: regionName,
              },
            };
          });
          this.availableProducts.update(availableProducts => {
            return {
              ...availableProducts,
              egw: [...availableProducts.egw, this.egw()[cardName]],
            };
          });
          this.typeOfCard.update(typeOfCard => {
            return { ...typeOfCard, [cardName]: 'egw' };
          });
          this.routeOfCard.update(routeOfCard => {
            return { ...routeOfCard, [cardName]: ['warning'] };
          });
          if (!this.useStoredDashboard) {
            this.cards.update(cards => {
              return [...cards, cardName];
            });
          }
          this.egwRegionSelectControls.update(egwRegionSelectControls => {
            return {
              ...egwRegionSelectControls,
              [cardName]: new UntypedFormControl(egwSeason + '_' + egwRegion),
            };
          });
        }
      }
    }
    this.egwRegionSelectControls.update(egwRegionSelectControls => {
      return {
        ...egwRegionSelectControls,
        ['egw']: new UntypedFormControl(null, Validators.required),
      };
    });

    if (this.useStoredDashboard) {
      for (const card of this.cards()) {
        if (
          this.typeOfCard()[card] === 'egw' &&
          !this.egwRegionSelectControls().hasOwnProperty(card)
        ) {
          this.onRemoveCard(card);
        }
      }
    }
  }

  initAmpel(): void {
    if (this.auth.isProductActive('trafficLightsProducts')) {
      this.isSomethingOrdered.set(true);
      if (!this.useStoredDashboard) {
        this.cards.update(cards => {
          return [...cards, 'ampel'];
        });
      }
      this.typeOfCard.update(typeOfCard => {
        return { ...typeOfCard, ['ampel']: 'ampel' };
      });
      this.availableProducts.update(availableProducts => {
        return {
          ...availableProducts,
          ampel: [...availableProducts.ampel, 'ampel'],
        };
      });
    } else if (this.useStoredDashboard && this.cards().indexOf('ampel') >= 0) {
      this.onRemoveCard('ampel');
    }
  }

  async initWarnmap(): Promise<void> {
    if (this.auth.isProductActive('warnmapProducts')) {
      this.isSomethingOrdered.set(true);
      const customerDocument = this.auth.getCustomerDocument();
      const cardNames = [];
      this.warnmap.set({});
      for (const product of customerDocument['warnmapProducts']) {
        if (this.auth.isProductActive('warnmapProducts', product.id)) {
          for (const detail of product.warnmapDetails) {
            const source = detail.source;
            const parameter =
              detail.parameters.length > 0 ? detail.parameters[0] : 'ALL';
            if (!this.availableProducts().warnmap.hasOwnProperty(source)) {
              this.availableProducts.update(availableProducts => {
                return {
                  ...availableProducts,
                  ['warnmap']: { ...availableProducts.warnmap, [source]: [] },
                };
              });
              const cardName = 'warnmap_' + source + '_' + parameter;
              this.warnmapSourceSelectControls.update(
                warnmapSourceSelectControls => {
                  warnmapSourceSelectControls[cardName] =
                    new FormControl<string>(source);
                  return { ...warnmapSourceSelectControls };
                }
              );
              this.warnmapParameterSelectControls.update(
                warnmapParameterSelectControls => {
                  warnmapParameterSelectControls[cardName] =
                    new FormControl<string>(parameter);
                  return { ...warnmapParameterSelectControls };
                }
              );
            }
            for (const parameter of detail.parameters) {
              if (
                this.availableProducts().warnmap[source].indexOf(parameter) < 0
              ) {
                this.availableProducts.update(availableProducts => {
                  availableProducts.warnmap[source].push(parameter);
                  return {
                    ...availableProducts,
                  };
                });
                const cardName = 'warnmap_' + source + '_' + parameter;
                this.typeOfCard.update(typeOfCard => {
                  return { ...typeOfCard, [cardName]: 'warnmap' };
                });
                cardNames.push(cardName);
                this.warnmap.update(warnmap => {
                  return {
                    ...warnmap,
                    [cardName]: {
                      source: source,
                      parameter: parameter,
                    },
                  };
                });
                if (!this.useStoredDashboard) {
                  this.cards.update(cards => {
                    return [...cards, cardName];
                  });
                }
              }
            }
          }
        }
      }
    } else {
      if (this.useStoredDashboard && this.cards().indexOf('warnmap') >= 0) {
        this.onRemoveCard('warnmap');
      }
    }
    this.warnmapSourceSelectControls.update(warnmapSourceSelectControls => {
      warnmapSourceSelectControls['warnmap'] = new FormControl<string>(
        null,
        Validators.required
      );
      return { ...warnmapSourceSelectControls };
    });
    this.warnmapParameterSelectControls.update(
      warnmapParameterSelectControls => {
        warnmapParameterSelectControls['warnmap'] = new FormControl<string>(
          null,
          Validators.required
        );
        return { ...warnmapParameterSelectControls };
      }
    );
  }

  initDwdMap(): void {
    if (this.auth.getLanguage() === 'de') {
      if (!this.useStoredDashboard) {
        this.cards.update(cards => {
          return [...cards, 'dwd'];
        });
      }
      this.typeOfCard.update(typeOfCard => {
        return { ...typeOfCard, ['dwd']: 'dwd' };
      });
      this.availableProducts.update(availableProducts => {
        return {
          ...availableProducts,
          dwd: [...availableProducts.dwd, 'dwd'],
        };
      });
    } else if (this.useStoredDashboard && this.cards().indexOf('dwd') >= 0) {
      this.onRemoveCard('dwd');
    }
  }

  async initDwdWarnmap(): Promise<void> {
    const customerDocument = this.auth.getCustomerDocument();
    const customerId = customerDocument.customerId;
    const customerCountry =
      await this.dashboardInfoService.getCustomerCountry(customerId);
    if (customerCountry === 'de') {
      if (customerDocument.warnmapProducts.length === 0) {
        const cardName = 'warnmap_dwd_ALL';
        if (!this.useStoredDashboard) {
          this.cards.update(cards => {
            return [...cards, cardName];
          });
        }
        this.typeOfCard.update(typeOfCard => {
          return { ...typeOfCard, [cardName]: 'warnmap' };
        });
        this.availableProducts.update(availableProducts => {
          return {
            ...availableProducts,
            ['warnmap']: { ...availableProducts.warnmap, ['dwd']: ['ALL'] },
          };
        });
        if (isNil(this.warnmap())) {
          this.warnmap.set({});
        }
        this.warnmap.update(warnmap => {
          return {
            ...warnmap,
            [cardName]: {
              source: 'dwd',
              parameter: 'ALL',
            },
          };
        });
      }
    }
  }

  updateDwdMap(): void {
    this.safeUrlDwdMap.set('assets/images/WM-loading.gif');
    setTimeout(() => {
      this.safeUrlDwdMap.set(
        this.sanitizer.bypassSecurityTrustResourceUrl(
          this.urlDwdMap + '&refresh' + this.refresh().dwd
        )
      );
    }, 100);
  }

  initGmaAlarm(): void {
    if (this.auth.isProductActive('egwGmaProducts')) {
      this.topCards.update(topCards => {
        return [...topCards, 'gmaAlarm'];
      });
    }
  }

  initSmw(): void {
    const customerDocument = this.auth.getCustomerDocument();
    const stations = {
      gma: [],
      synop: [],
    };
    const names = {};
    for (const smwProduct of customerDocument['smwProducts']) {
      if (this.auth.isProductActive('smwProducts', smwProduct.id)) {
        this.isSomethingOrdered.set(true);
        for (const station of smwProduct.stations) {
          if (
            !this.auth.isUserAllowedToAccessToProduct(
              smwProduct.id,
              station.stationId
            )
          ) {
            continue;
          }
          const stationType = station.stationType === 'gma' ? 'gma' : 'synop';
          if (stations[stationType].indexOf(station.stationId < 0)) {
            stations[stationType].push(station.stationId);
            names[station.stationId] = station.overwriteStationName;
          }
        }
      }
    }
    if (this.useStoredDashboard) {
      if (stations.gma.length === 0 && this.cards().indexOf('smw_gma') >= 0) {
        this.onRemoveCard('smw_gma');
      }
      if (
        stations.synop.length === 0 &&
        this.cards().indexOf('smw_synop') >= 0
      ) {
        this.onRemoveCard('smw_synop');
      }
    }
    if (stations.gma.length === 0 && stations.synop.length === 0) {
      return;
    }
    this.smw.set({});
    for (const statType of ['gma', 'synop']) {
      if (stations[statType].length > 0) {
        const cardName = 'smw_' + statType;
        this.smw.update(smw => {
          return {
            ...smw,
            [cardName]: {
              stationType: statType,
              stations: stations[statType],
              stationNames: names,
              card: cardName,
            },
          };
        });
        if (!this.useStoredDashboard) {
          this.cards.update(cards => {
            return [...cards, cardName];
          });
        }
        this.typeOfCard.update(typeOfCard => {
          return { ...typeOfCard, [cardName]: 'smw' };
        });
        this.routeOfCard.update(routeOfCard => {
          return { ...routeOfCard, [cardName]: ['smw'] };
        });
        this.availableProducts.update(availableProducts => {
          return {
            ...availableProducts,
            smw: [...availableProducts.smw, statType],
          };
        });
        this.smwRegionSelectControls.update(smwRegionSelectControls => {
          return {
            ...smwRegionSelectControls,
            [cardName]: new UntypedFormControl(statType, Validators.required),
          };
        });
      }
    }
    this.smwRegionSelectControls.update(smwRegionSelectControls => {
      return {
        ...smwRegionSelectControls,
        ['smw']: new UntypedFormControl(null, Validators.required),
      };
    });
  }

  initEpp(): void {
    const customerDocument = this.auth.getCustomerDocument();
    const customerId = customerDocument['customerId'];
    if (customerDocument.hasOwnProperty('eppProducts')) {
      if (customerDocument['eppProducts'].length > 0) {
        this.epp.set({});
        const orderedStations = [];
        const initialEppCards = { meteogram: false, table: false };
        for (const eppProduct of customerDocument['eppProducts']) {
          if (this.auth.isProductActive('eppProducts', eppProduct.id)) {
            this.isSomethingOrdered.set(true);
            let counter = 0;
            for (const eppStation of eppProduct['stations']) {
              counter++;
              if (customerId === 10560 && counter > 20) break;
              if (
                !this.auth.isUserAllowedToAccessToProduct(
                  eppProduct.id,
                  eppStation.stationId
                )
              ) {
                continue;
              }
              orderedStations.push(eppStation);
              for (const eppResolution of eppProduct['resolutions']) {
                if (eppResolution.days < 1) continue;
                for (const eppParameterset of eppProduct['parameter_sets'].sort(
                  (a, b) => (a < b ? 1 : -1)
                )) {
                  for (const eppView of ['meteogram', 'table']) {
                    const cardName =
                      'epp_' +
                      eppView +
                      '_' +
                      eppParameterset +
                      '_' +
                      eppResolution.days +
                      '_' +
                      eppStation.stationId;
                    this.epp.update(epp => {
                      return {
                        ...epp,
                        [cardName]: {
                          station: eppStation,
                          resolution: eppResolution,
                          parameterset: eppParameterset,
                          allParametersets: eppProduct['parameter_sets'],
                          view: eppView,
                          card: cardName,
                        },
                      };
                    });
                    this.typeOfCard.update(typeOfCard => {
                      return { ...typeOfCard, [cardName]: 'epp' };
                    });
                    this.routeOfCard.update(routeOfCard => {
                      return {
                        ...routeOfCard,
                        [cardName]: ['epp', eppStation.stationId],
                      };
                    });
                    if (!initialEppCards[eppView]) {
                      if (!this.useStoredDashboard) {
                        this.cards.update(cards => {
                          return [...cards, cardName];
                        });
                      }
                      initialEppCards[eppView] = true;
                    }
                    this.eppStationSelectControls.update(
                      eppStationSelectControls => {
                        return {
                          ...eppStationSelectControls,
                          [cardName]: new UntypedFormControl(
                            eppStation.stationId
                          ),
                        };
                      }
                    );
                    this.eppParametersetSelectControls.update(
                      eppParametersetSelectControls => {
                        return {
                          ...eppParametersetSelectControls,
                          [cardName]: new UntypedFormControl(eppParameterset),
                        };
                      }
                    );
                    this.eppResolutionSelectControls.update(
                      eppResolutionSelectControls => {
                        return {
                          ...eppResolutionSelectControls,
                          [cardName]: new UntypedFormControl(
                            eppResolution.days
                          ),
                        };
                      }
                    );
                    this.eppViewSelectControls.update(eppViewSelectControls => {
                      return {
                        ...eppViewSelectControls,
                        [cardName]: new UntypedFormControl(eppView),
                      };
                    });
                  }
                }
              }
            }
            this.availableProducts.update(availableProducts => {
              return {
                ...availableProducts,
                epp: [
                  ...availableProducts.epp,
                  {
                    parametersets: eppProduct['parameter_sets'],
                    resolutions: eppProduct['resolutions'],
                    stations: orderedStations,
                  },
                ],
              };
            });

            // break;
          }
        }
      }
    }
    this.eppViewSelectControls.update(eppViewSelectControls => {
      return {
        ...eppViewSelectControls,
        ['epp']: new UntypedFormControl(null, Validators.required),
      };
    });
    this.eppResolutionSelectControls.update(eppResolutionSelectControls => {
      return {
        ...eppResolutionSelectControls,
        ['epp']: new UntypedFormControl(null, Validators.required),
      };
    });
    this.eppStationSelectControls.update(eppStationSelectControls => {
      return {
        ...eppStationSelectControls,
        ['epp']: new UntypedFormControl(null, Validators.required),
      };
    });
    this.eppParametersetSelectControls.update(eppParametersetSelectControls => {
      return {
        ...eppParametersetSelectControls,
        ['epp']: new UntypedFormControl(null, Validators.required),
      };
    });

    // check stored cards
    if (this.useStoredDashboard) {
      for (const card of this.cards()) {
        if (
          this.typeOfCard()[card] === 'epp' &&
          !this.eppStationSelectControls().hasOwnProperty(card)
        ) {
          this.onRemoveCard(card);
        }
      }
    }
  }

  async initEgp(): Promise<void> {
    const customerDocument = this.auth.getCustomerDocument();
    if (this.auth.isPigeonCustomer()) {
      return;
    }
    let egpRegion;
    let egpSeason: EgpSeason;
    const egpProducts = customerDocument['egpProducts'].concat(
      customerDocument['egpSummerProducts']
    );
    if (egpProducts.length > 0) {
      this.egp.set({});
      for (const egpProduct of egpProducts) {
        if (
          egpProduct !== undefined &&
          (this.auth.isProductActive('egpProducts', egpProduct.id) ||
            this.auth.isProductActive('egpSummerProducts', egpProduct.id))
        ) {
          this.isSomethingOrdered.set(true);
          egpRegion = egpProduct['areaId'];
          egpSeason =
            egpProduct['classType'] === 'EGPProduct'
              ? EgpSeason.WINTER
              : EgpSeason.SUMMER;

          for (const egpView of ['riskbox', 'text'] as const) {
            const cardName = this.buildEgpCardName(
              egpView,
              egpSeason,
              egpRegion
            );

            if (!this.useStoredDashboard && egpView === 'riskbox') {
              this.cards.update(cards => {
                return [...cards, cardName];
              });
            }

            this.typeOfCard.update(typeOfCard => {
              return { ...typeOfCard, [cardName]: 'egp' };
            });

            this.routeOfCard.update(routeOfCard => {
              return {
                ...routeOfCard,
                [cardName]: ['/egp', egpSeason + '_' + egpRegion],
              };
            });

            this.egp.update(egp => {
              return {
                ...egp,
                [cardName]: {
                  region: egpRegion,
                  name: this.egpRegionName(egpRegion, egpSeason),
                  season: egpSeason,
                  view: egpView,
                  card: cardName,
                },
              };
            });

            this.egpRegionSelectControls.update(egpRegionSelectControls => {
              return {
                ...egpRegionSelectControls,
                [cardName]: new UntypedFormControl(egpSeason + '_' + egpRegion),
              };
            });

            this.egpViewSelectControls.update(egpViewSelectControls => {
              return {
                ...egpViewSelectControls,
                [cardName]: new UntypedFormControl(egpView),
              };
            });
          }

          const defaultCardName = this.buildEgpCardName(
            'riskbox',
            egpSeason,
            egpRegion
          );

          this.availableProducts.update(availableProducts => {
            return {
              ...availableProducts,
              egp: [...availableProducts.egp, this.egp()[defaultCardName]],
            };
          });
        }
      }
    }

    this.egpRegionSelectControls.update(egpRegionSelectControls => {
      return {
        ...egpRegionSelectControls,
        ['egp']: new UntypedFormControl(egpSeason + '_' + egpRegion),
      };
    });

    this.egpViewSelectControls.update(egpViewSelectControls => {
      return {
        ...egpViewSelectControls,
        ['egp']: new UntypedFormControl('riskbox', Validators.required),
      };
    });

    // check stored cards
    if (this.useStoredDashboard) {
      for (const card of this.cards()) {
        if (this.typeOfCard()[card] === 'egp') {
          const parsed = this.parseEgpCardName(card);
          const normalizedCardName = this.buildEgpCardName(
            parsed.view,
            parsed.season,
            parsed.region
          );

          if (
            !this.egpRegionSelectControls().hasOwnProperty(normalizedCardName)
          ) {
            this.onRemoveCard(card);
          }
        }
      }
    }
  }

  initRadar(): void {
    const zoomPoints = {};
    const customerDocument = this.auth.getCustomerDocument();
    if (customerDocument.hasOwnProperty('radarProducts')) {
      if (customerDocument['radarProducts'].length > 0) {
        this.radar.set({});
        const initialRadarCards = [];
        for (const radarProduct of customerDocument['radarProducts']) {
          if (this.auth.isProductActive('radarProducts', radarProduct.id)) {
            this.isSomethingOrdered.set(true);
            const region = radarProduct['region'] || 'de';
            if (this.radarRegions.indexOf(region) < 0) {
              this.radarRegions.push(region);
              const searchName = 'whole Area';
              zoomPoints[region] = [{ searchName }];
              const cardName = 'radar_' + region + '_' + searchName;
              this.radar.update(radar => {
                return {
                  ...radar,
                  [cardName]: {
                    region,
                    zoomPoint: {
                      searchName,
                      longitude: this.radarService.centerWholeArea[region][0],
                      latitude: this.radarService.centerWholeArea[region][1],
                    },
                    card: cardName,
                  },
                };
              });
              this.typeOfCard.update(typeOfCard => {
                return { ...typeOfCard, [cardName]: 'radar' };
              });
              this.routeOfCard.update(routeOfCard => {
                return {
                  ...routeOfCard,
                  [cardName]: ['radar'],
                };
              });
              if (
                !this.useStoredDashboard &&
                initialRadarCards.indexOf(region) < 0
              ) {
                this.cards.update(cards => {
                  return [...cards, cardName];
                });
                initialRadarCards.push(region);
              }

              this.radarRegionSelectControl.update(radarRegionSelectControl => {
                return {
                  ...radarRegionSelectControl,
                  [cardName]: new UntypedFormControl(region),
                };
              });
              this.radarZoomSelectControl.update(radarZoomSelectControl => {
                return {
                  ...radarZoomSelectControl,
                  [cardName]: new UntypedFormControl(searchName),
                };
              });
            }
            for (const zoomPoint of radarProduct['points']) {
              const searchName = zoomPoint.searchName;
              if (
                zoomPoints[region].filter(z => z.searchName === searchName)
                  .length === 0
              ) {
                zoomPoints[region].push(zoomPoint);
                const cardName = 'radar_' + region + '_' + searchName;
                this.radar.update(radar => {
                  return {
                    ...radar,
                    [cardName]: {
                      region,
                      zoomPoint,
                      card: cardName,
                    },
                  };
                });
                this.typeOfCard.update(typeOfCard => {
                  return { ...typeOfCard, [cardName]: 'radar' };
                });
                this.routeOfCard.update(routeOfCard => {
                  return {
                    ...routeOfCard,
                    [cardName]: ['radar'],
                  };
                });
                if (
                  !this.useStoredDashboard &&
                  initialRadarCards.indexOf(region) < 0
                ) {
                  this.cards.update(cards => {
                    return [...cards, cardName];
                  });
                  initialRadarCards.push(region);
                }

                this.radarRegionSelectControl.update(
                  radarRegionSelectControl => {
                    return {
                      ...radarRegionSelectControl,
                      [cardName]: new UntypedFormControl(region),
                    };
                  }
                );

                this.radarZoomSelectControl.update(radarZoomSelectControl => {
                  return {
                    ...radarZoomSelectControl,
                    [cardName]: new UntypedFormControl(searchName),
                  };
                });
              }
            }
          }
        }
        this.radarRegionSelectControl.update(radarRegionSelectControl => {
          return {
            ...radarRegionSelectControl,
            ['radar']: new UntypedFormControl(null, Validators.required),
          };
        });

        this.radarZoomSelectControl.update(radarZoomSelectControl => {
          return {
            ...radarZoomSelectControl,
            ['radar']: new UntypedFormControl(null, Validators.required),
          };
        });
      }
    }
    // check stored cards
    if (this.useStoredDashboard) {
      for (const card of this.cards()) {
        if (
          this.typeOfCard()[card] === 'radar' &&
          !this.radarRegionSelectControl().hasOwnProperty(card)
        ) {
          this.onRemoveCard(card);
        }
      }
    }
    for (const region of this.radarRegions) {
      this.availableProducts.update(availableProducts => {
        return {
          ...availableProducts,
          radar: { ...availableProducts.radar, [region]: zoomPoints[region] },
        };
      });
    }
    this.updateRadar();
  }

  updateRadar(): void {
    const obsRunTypes = {
      de: 0,
      benelux: 4,
      es: 14,
      fr: 16,
      ch: 18,
    };
    for (const region of this.radarRegions) {
      this.radarService.getLatestObsRun(obsRunTypes[region]).subscribe(data => {
        if (data.length > 0) {
          this.radarDtg.update(radarDtg => {
            return { ...radarDtg, [region]: moment(data[0].dtg) };
          });
        }
      });
    }
  }

  getZoomPoint(region: string, searchName: string): any {
    const regionZoomPoints = this.availableProducts().radar?.[region];

    if (Array.isArray(regionZoomPoints)) {
      for (const zoomPoint of regionZoomPoints) {
        if (
          searchName === zoomPoint.searchName &&
          searchName !== 'whole Area'
        ) {
          return zoomPoint;
        }
      }
    } else {
      // availableProducts().radar has no entry for this region, even though
      // it's offered as a dashboard radar-card region (radarRegions is built
      // from customerDocument.radarProducts, a different source that can
      // diverge from availableProducts().radar). Report it so the mismatch
      // stays visible, but fall back to "whole Area" instead of crashing.
      rg4js('send', {
        error: new Error(
          `getZoomPoint: no availableProducts().radar entry for region "${region}"`
        ),
        customData: {
          availableProducts: JSON.stringify(this.availableProducts()),
          region,
        },
      });
    }

    return {
      searchName: 'whole Area',
      longitude: this.radarService.centerWholeArea[region][0],
      latitude: this.radarService.centerWholeArea[region][1],
    };
  }

  onEppLastIssueTimeChange(card: string, lastIssueTime: string): void {
    this.eppLastIssueTimes.update(eppLastIssueTimes => {
      return {
        ...eppLastIssueTimes,
        [card]: lastIssueTime,
      };
    });
  }

  onNavigateTo(route: Array<string>): void {
    if (route && route[0] === 'dwd') {
      window.open(
        'https://www.dwd.de/DE/wetter/warnungen_gemeinden/warnWetter_node.html',
        '_blank'
      );
    } else if (route) {
      this.router.navigate(route);
    }
  }

  onSendMail(): void {
    const url =
      'https://www.einsatzwetter.de/feedback-' + this.auth.getLanguage();
    window.open(url, '_blank');
  }

  onDrop(event: CdkDragDrop<string[]>): void {
    if (event.previousIndex === event.currentIndex) {
      return;
    }

    this.cards.update(cards => {
      const updatedCards = [...cards];
      moveItemInArray(updatedCards, event.previousIndex, event.currentIndex);
      return updatedCards;
    });

    this.saveDashboardSettings();
  }

  onSaveRadarSettings(cardName: string, action: string): void {
    const radarRegionSelectControl = this.radarRegionSelectControl();
    const radarRegion = radarRegionSelectControl[cardName].value;
    const searchName = this.radarZoomSelectControl()[cardName].value;
    const newCardName = 'radar_' + radarRegion + '_' + searchName;
    this.radar.update(radar => {
      return {
        ...radar,
        [newCardName]: {
          region: radarRegion,
          zoomPoint: this.getZoomPoint(radarRegion, searchName),
        },
      };
    });
    if (!radarRegionSelectControl.hasOwnProperty(newCardName)) {
      this.radarRegionSelectControl.update(rsc => {
        return {
          ...rsc,
          [newCardName]: new UntypedFormControl(radarRegion),
        };
      });
      this.radarZoomSelectControl.update(radarZoomSelectControl => {
        return {
          ...radarZoomSelectControl,
          [newCardName]: new UntypedFormControl(searchName),
        };
      });
    } else {
      this.radarRegionSelectControl.update(rsc => {
        rsc[newCardName].setValue(radarRegion);
        return {
          ...rsc,
        };
      });
      this.radarZoomSelectControl.update(radarZoomSelectControl => {
        radarZoomSelectControl[newCardName].setValue(searchName);
        return { ...radarZoomSelectControl };
      });
    }
    this.setCard('radar', action, cardName, newCardName);
  }

  onSaveEgpSettings(cardName: string, action: string): void {
    const [egpSeason, egpRegion] =
      this.egpRegionSelectControls()[cardName].value.split('_');

    const view = this.egpViewSelectControls()[cardName]?.value ?? 'riskbox';

    const newCardName = this.buildEgpCardName(view, egpSeason, egpRegion);

    this.setCard('egp', action, cardName, newCardName);
  }

  private closeDashboardSettings(): void {
    this.selectedDashboardCard.set(null);
    this.showSettings.set(false);
    this.drawer()?.close();
  }

  onSaveEgwSettings(cardName: string, action: string): void {
    const [egpSeason, egpRegion] =
      this.egwRegionSelectControls()[cardName].value.split('_');
    const newCardName = 'egw_' + egpSeason + '_' + egpRegion;
    this.setCard('egw', action, cardName, newCardName);
  }

  onAddAmpel(): void {
    this.setCard('ampel', 'add', 'ampel', 'ampel');
  }

  onAddDwd(): void {
    this.setCard('dwd', 'add', 'dwd', 'dwd');
  }

  onSaveWarnmapCfg(cardName: string, action: string): void {
    console.log(
      'onSaveWarnmapCfg',
      cardName,
      action,
      this.warnmapSourceSelectControls(),
      this.warnmapParameterSelectControls()
    );
    const source = this.warnmapSourceSelectControls()[cardName].value;
    const parameter = 'ALL'; // this.warnmapParameterSelectControls[cardName].value;
    const newCardName = 'warnmap_' + source + '_' + parameter;

    if (!this.warnmapSourceSelectControls().hasOwnProperty(newCardName)) {
      this.warnmapSourceSelectControls.update(warnmapSourceSelectControls => {
        warnmapSourceSelectControls[newCardName] = new FormControl<string>(
          source
        );
        return { ...warnmapSourceSelectControls };
      });
      this.warnmapParameterSelectControls.update(
        warnmapParameterSelectControls => {
          warnmapParameterSelectControls[newCardName] = new FormControl<string>(
            parameter
          );
          return { ...warnmapParameterSelectControls };
        }
      );
    } else {
      this.warnmapSourceSelectControls.update(warnmapSourceSelectControls => {
        warnmapSourceSelectControls[newCardName].setValue(source);
        return { ...warnmapSourceSelectControls };
      });
      this.warnmapParameterSelectControls.update(
        warnmapParameterSelectControls => {
          warnmapParameterSelectControls[newCardName].setValue(parameter);
          return { ...warnmapParameterSelectControls };
        }
      );
    }
    this.setCard('warnmap', action, cardName, newCardName);
  }

  onSaveSmwSettings(cardName: string, action: string): void {
    const statType = this.smwRegionSelectControls()[cardName].value;
    const newCardName = 'smw_' + statType;
    this.setCard('smw', action, cardName, newCardName);
  }

  onSaveEppSettings(cardName: string, action: string): void {
    const view = this.eppViewSelectControls()[cardName].value;
    const parameterset = this.eppParametersetSelectControls()[cardName].value;
    const stationId = this.eppStationSelectControls()[cardName].value;
    const resolution = this.eppResolutionSelectControls()[cardName].value;
    const newCardName =
      'epp_' + view + '_' + parameterset + '_' + resolution + '_' + stationId;
    this.setCard('epp', action, cardName, newCardName);
  }

  closeAccordions(): void {
    this.accordionAdd()?.closeAll();
    this.accordionEdit()?.closeAll();
  }

  saveDashboardSettings(): void {
    if (!this.auth.getCustomerAlias()) {
      localStorage.setItem('dashboard', JSON.stringify(this.cards()));
      const userProfile = this.auth.getUserProfile();
      if (userProfile) {
        if (!userProfile['metadata']) {
          userProfile['metadata'] = {};
        }
        if (
          !userProfile['metadata'].hasOwnProperty('global') ||
          !userProfile['metadata']['global']
        ) {
          userProfile['metadata']['global'] = {};
        }
        const global = userProfile['metadata']['global'];
        global['dashboard'] = this.cards();
        this.auth.updateUserData('global', global);
      }
    }
  }

  setCard(
    product: string,
    action: string,
    oldCardName: string,
    newCardName: string
  ): void {
    this.typeOfCard.update(typeOfCard => {
      return { ...typeOfCard, [newCardName]: product };
    });

    if (action === 'edit') {
      this.replaceCard(oldCardName, newCardName);
    } else {
      const pos = this.positionSelectControls[product].value;
      if (pos === this.cards().length) {
        this.cards.update(cards => {
          return [...cards, newCardName];
        });
      } else {
        this.cards.update(cards => {
          const updatedCards = [...cards];
          updatedCards.splice(pos, 0, newCardName);
          return updatedCards;
        });
      }
      this.saveDashboardSettings();
    }

    this.closeAccordions();
    this.closeDashboardSettings();
  }

  replaceCard(oldCardName: string, newCardName: string): void {
    this.cards.update(cards => {
      const cardPos = cards.indexOf(oldCardName);

      if (cardPos < 0) {
        return cards;
      }

      const updatedCards = [...cards];

      if (oldCardName === newCardName) {
        return updatedCards;
      }

      updatedCards.splice(cardPos, 1, newCardName);
      return updatedCards;
    });

    this.selectedDashboardCard.set(newCardName);
    this.saveDashboardSettings();
  }

  onRemoveCard(cardName: string): void {
    this.cards.update(cards => {
      cards.splice(cards.indexOf(cardName), 1);
      return [...cards];
    });
    this.saveDashboardSettings();
  }
}
